import {CustomCheckbox} from '@/_application/core/components/ui/forms/checkbox/custom-checkbox';
import {Image} from '@/_application/core/components/ui/image';
import Modal from '@/_application/core/components/ui/modal/modal';
import {WebStorage} from '@/_application/core/storage/web-storage';
import {getImageAssetUrl} from '@/_application/core/utils/common';
import {Product} from '@/_application/modules/products/model/product';
import {useNotificationsProductBySku} from '@/framework/product';
import {PRODUCT_NOTIFICATION_IDS_KEY} from '@/lib/constants';
import {Button} from '@kidslabs/mario-ui-nextjs-react-core';
import React, {ChangeEvent, useEffect, useState} from 'react';

const IconHeart = getImageAssetUrl('images/heart.png');

const NotificationPopup = ({product}: {product: Product}) => {
    const [isOpenPopup, setIsOpenPopup] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [notificationId, setNotificationId] = useState<string | null>(null);

    const {getNotificationsProduct, notifications, error, isLoading} = useNotificationsProductBySku();

    useEffect(() => {
        if (product.sku) {
            getNotificationsProduct(product.sku);
        }
    }, [product.sku, getNotificationsProduct]);

    useEffect(() => {
        if (notifications) {
            const notificationId = notifications.notification_id;
            setNotificationId(notificationId);
            const storedNotificationIds = JSON.parse(WebStorage.getItem(PRODUCT_NOTIFICATION_IDS_KEY) ?? '{}');
            const isShowNotification = notifications?.notification_id && !storedNotificationIds[notificationId];
            if (isShowNotification) {
                setIsOpenPopup(true);
            }
        }
    }, [notifications]);

    const handleCloseModal = () => {
        setIsOpenPopup(false);
    };

    const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
        setIsChecked(e.target.checked);
    };

    const handleSubmit = () => {
        if (notificationId) {
            const storedNotificationIds = JSON.parse(WebStorage.getItem(PRODUCT_NOTIFICATION_IDS_KEY) ?? '{}');
            if (isChecked) {
                storedNotificationIds[notificationId] = true;
            } else {
                delete storedNotificationIds[notificationId];
            }
            WebStorage.setItem(PRODUCT_NOTIFICATION_IDS_KEY, JSON.stringify(storedNotificationIds));
        }
        handleCloseModal();
    };

    if ((!notifications && !isLoading) || error) return <></>;

    return (
        <>
            {isLoading ? (
                <></>
            ) : (
                <Modal open={isOpenPopup} onClose={handleCloseModal}>
                    <div className="relative mx-auto h-auto w-[95%] select-none overflow-hidden rounded-xl [background:var(--ocean-blue-gradient)] p-7 md:w-[592px]">
                        <h4 className="mb-3 border-b pb-1.5 text-center text-xl font-bold text-white">
                            {notifications?.title}
                        </h4>

                        <div
                            className="mx-auto mb-8 max-w-[408px] text-center text-base text-white"
                            dangerouslySetInnerHTML={{__html: notifications?.content}}></div>

                        <div className="z-10 mb-4 flex items-center justify-center">
                            <CustomCheckbox
                                name="notification"
                                label="Không hiển thị thông báo này lần sau"
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                            />
                        </div>

                        <div className="flex items-center justify-center">
                            <Button
                                variant="custom"
                                aria-label="Đồng ý"
                                onClick={handleSubmit}
                                className="mx-auto! block h-fit rounded-lg bg-KPZ_Yellow px-7! py-1.5 text-lg! font-extrabold! text-primary transition-colors hover:bg-yellow-300">
                                Đồng ý
                            </Button>
                        </div>

                        <Image
                            src={IconHeart}
                            alt="Heart"
                            height={154}
                            width={154}
                            className="absolute bottom-0 right-0 z-0 select-none"
                        />

                        <Image
                            src={IconHeart}
                            alt="Heart"
                            height={132}
                            width={147}
                            className="absolute left-12 top-10 z-0 rotate-12 select-none opacity-60"
                        />
                    </div>
                </Modal>
            )}
        </>
    );
};

export default NotificationPopup;
